import type { LinearGradient } from "types";

export type GradientDirection =
  | "left-right"
  | "top-bottom"
  | "diagonal-right"
  | "diagonal-left";

export const GRADIENT_GEOMETRIES: Record<GradientDirection, LinearGradient> = {
  "left-right": { type: "Linear", start: [0, 0.5], end: [1, 0.5] },
  "top-bottom": { type: "Linear", start: [0.5, 0], end: [0.5, 1] },
  "diagonal-right": { type: "Linear", start: [0, 0], end: [1, 1] },
  "diagonal-left": { type: "Linear", start: [1, 0], end: [0, 1] },
};

export const GRADIENT_DIRECTIONS = Object.keys(
  GRADIENT_GEOMETRIES
) as GradientDirection[];

export const getDirectionFromGeometry = (
  geometry: LinearGradient
): GradientDirection => {
  const match = GRADIENT_DIRECTIONS.find((key) => {
    const g = GRADIENT_GEOMETRIES[key];
    return (
      g.start[0] === geometry.start[0] &&
      g.start[1] === geometry.start[1] &&
      g.end[0] === geometry.end[0] &&
      g.end[1] === geometry.end[1]
    );
  });
  return match ?? "left-right";
};
